/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const createFilterPanelStyles = makeStyles(() => ({
  root: {
    marginBottom: '10px',
  },
  itemsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '-8px -5px',
  },
  filterItem: { flexGrow: 1, padding: '8px 5px' },
  search: {
    '& .MuiInputAdornment-root': {
      color: '#A2A7AE',
    },
  },
}));
